import { UseMutationOptions, useMutation } from '@tanstack/react-query';
import axiosInstance, { getAPIURL } from '../axiosInstance';
import { RespondConnection } from '../../types/Types';

export const useRespondConnection= (
  options?: UseMutationOptions<RespondConnection, unknown, RespondConnection, unknown>
) => {
  return useMutation({
    ...options,
    mutationFn: (data: RespondConnection) =>
      axiosInstance
        .put(getAPIURL(`/User/request/${data.requestId}/${data.senderId}/${data.accept}`), data)
        .then((res) => res.data),
  });
};